export const ExpensesConstants = {
    GET_EXPENSES_REQUEST: 'GET_EXPENSES_REQUEST',
    GET_EXPENSES_SUCCESS: 'GET_EXPENSES_SUCCESS',
    GET_EXPENSES_FAIL: 'GET_EXPENSES_FAIL',
}